import {
  Component, Input, Output, EventEmitter, HostBinding, OnChanges, SimpleChanges, SimpleChange, OnDestroy, ViewEncapsulation,
  ChangeDetectionStrategy, ChangeDetectorRef,
} from '@angular/core';
import { DataTable } from '../ng-data-table/base';
import { PageEvent } from '../../lib/pagination';
import { Subscription, concat } from 'rxjs';
import { downloadCSV, downloadPDF, Keys } from '../common';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

import { TitlePipe } from '../pipes';
import { CommonFilterService } from 'src/app/shared/services/common-filter/common-filter.service';
import { Router } from '@angular/router';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
  selector: 'dt-toolbar',
  templateUrl: './dt-toolbar.component.html',
  styleUrls: [
    './dt-toolbar.component.css',
    '../styles/input-group.css',
    '../styles/buttons.css',
    '../styles/input.css',
    '../pagination/pagination.component.css'//Adding Page size styles - IMP
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class DtToolbarComponent implements OnChanges, OnDestroy {

  @Input() table: DataTable;
  @Input() createAction: boolean;
  @Input() globalFilter: boolean = true;
  @Input() clickRows: boolean = false;
  @Input() exportIconAction: boolean;
  @Input() exportAction: boolean;
  @Input() exportKMLAction: boolean;
  @Input() columnToggleAction: boolean;
  @Input() clearAllFiltersAction: boolean;
  @Input() createMessage: string = 'Create';
  @Input() goMessage: string = 'Go';
  @Input() exportMessage: string = 'Export as Excel';
  @Input() exportPDFMessage: string = 'Export as PDF';
  @Input() exportCSVMessage: string = 'Export as CSV';
  @Input() exportKMLMessage: string = 'Export as GPS KML';
  @Input() searchMessage: string = 'Search...';
  @Input() actionsMessage: string = 'Actions';
  @Input() columnsMessage: string = 'Add More Columns';
  @Input() modifyFiltersMessage: string = 'Modify filters';
  @Input() clearFiltersMessage: string = 'Clear all filters';
  @Input() zIndexColumnToggler: number;
  isFilters: boolean = true;
  ismainFilterEnabled: boolean = true;
  @Input() rsltType: string;
  pages: number[];

  @Input()
  get perPage(): number { return this._perPage; }
  set perPage(value: number) {
    this._perPage = value;
    this.pages = this.getPages();
  }
  private _perPage: number = 10;

  @Input()
  get pageSizeOptions(): number[] { return this._pageSizeOptions; }
  set pageSizeOptions(value: number[]) {
    this._pageSizeOptions = (value || []).sort((a, b) => a - b);
  }
  private _pageSizeOptions: number[] = [];

  @Output() pageChanged = new EventEmitter();
  @Output() downloaded = new EventEmitter();
  @Output() calleventErrorEvents = new EventEmitter();
  @Output() connDropEvents = new EventEmitter();

  @Input()
  get totalItems(): number { return this._totalItems; }
  set totalItems(value: number) {
    this._totalItems = value;
    //console.log(value)
    this.pages = this.getPages();
  }
  private _totalItems: number = 0;

  @Input()
  get currentPage(): number { return this._currentPage; }
  set currentPage(value: number) {
    const _previous = this._currentPage;
    this._currentPage = (value > this.totalPages()) ? this.totalPages() : (value || 1);

    if (_previous === this._currentPage || typeof _previous === 'undefined') {
      return;
    }
    this.pages = this.getPages();
  }
  private _currentPage: number = 1;


  SortCols: string = '';


  @Output() create: EventEmitter<any> = new EventEmitter();
  @Output() clearFilters: EventEmitter<any> = new EventEmitter();

  @HostBinding('class.dt-toolbar') cssClass = true;

  private subscriptions: Subscription[] = [];
  TSSelected: number = 1;

  isDeskTop = true;
  constructor(private cd: ChangeDetectorRef, private titlePipe: TitlePipe, private commonFilterService: CommonFilterService, private router: Router, private responsive: BreakpointObserver) {
    
    this.commonFilterService.TSType.subscribe(res => { this.TSSelected = res; });//TsType

    //console.log(this.SortCols)
    this.commonFilterService.isFilters$.subscribe(res => {
      this.isFilters = res;
    });
    //if (this.rsltType == 'call-events') {
      this.commonFilterService.filterCallEventErrorEvent.subscribe(res => {
        this.callEventErrorOrNot = res;
      });
    //}
    //if (this.rsltType == 'nettest') {
      this.commonFilterService.filterConnDrop.subscribe(res => {
        this.connDropOrNot = res;
      });
    //}

    ////////// check if user previlege configed any mainfilter or not
    if (sessionStorage.getItem('SystemSettings')) {
      this.ismainFilterEnabled = JSON.parse(sessionStorage.getItem('SystemSettings')).ismainFilterEnabled;
    }
     ////////////////////

    this.responsive.observe(['(min-width: 960px)', '(max-width: 1279.99px)', '(min-width: 1280px)', Breakpoints.Web, Breakpoints.WebLandscape, Breakpoints.WebPortrait,
      Breakpoints.Tablet, Breakpoints.TabletPortrait, Breakpoints.TabletLandscape,
      Breakpoints.Handset, Breakpoints.HandsetLandscape, Breakpoints.HandsetPortrait,
      Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge
    ])
      .subscribe(result => {

        const breakpoints = result.breakpoints;
        if (breakpoints[Breakpoints.Tablet] || breakpoints[Breakpoints.TabletPortrait] || breakpoints[Breakpoints.TabletLandscape]
          || breakpoints[Breakpoints.Handset] || breakpoints[Breakpoints.HandsetPortrait] || breakpoints[Breakpoints.HandsetLandscape]
          || breakpoints[Breakpoints.XSmall] || breakpoints[Breakpoints.Small]) {
          this.isDeskTop = false;
          if ((breakpoints['(min-width: 960px)'] && breakpoints['(max-width: 1279.99px)']) || breakpoints['(min-width: 1280px)']) {
            this.isDeskTop = true;
          }
        }
        else if (breakpoints[Breakpoints.Medium]) {
          this.isDeskTop = false;
        }
        else {
          this.isDeskTop = true;
        }
      });

  }

  //ngOnInit() {
  hasFilters: boolean = false;
  //hasMoreColumns: boolean;

  ngOnChanges(changes: SimpleChanges) {
    //debugger;
    this.commonFilterService.AllGeneralFilter.subscribe(res => {
      let genArr = res.filter(el => {
        return el["ColumnName"].toUpperCase() != this.SetTimestampSearch(this.TSSelected).toUpperCase();
      });
      this.hasFilters = genArr.length <= 0 ? false : true;
    });
    //this.hasFilters = this.table.dataFilter.hasFilters();
    //console.log(this.table.sorter.sortMeta.length)
    //this.hasMoreColumns = this.table.rsltType == 'pesq' ? true : false;
    const subFilter = this.table.events.filterSource$.subscribe(() => {
      //console.log('filter')
      this.cd.markForCheck();
    });
    const subSort = this.table.events.sortSource$.subscribe(() => {
      //console.log('sort')
      this.cd.markForCheck();
      let sortMeta = this.table.sorter.sortMeta;
      this.SortCols = "";
      for (const key in sortMeta) {
        if (sortMeta[key]) {
          let order = sortMeta[key].order;
          let orderText = (order === -1) ? 'DESC' : (order === 1) ? 'ASC' : '';
          this.SortCols += this.titlePipe.transform(sortMeta[key].title) + ' ' + orderText + ', ';
        }
      }

      this.SortCols = this.SortCols.substring(0, this.SortCols.length - 2);
    });
    this.subscriptions.push(subFilter);
    this.subscriptions.push(subSort);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  onClickGlobalSearch() {
    this.table.events.onFilter();
  }

  onKeyPressGlobalSearch(event: KeyboardEvent) {
    if (event.which === Keys.ENTER) {
      this.table.events.onFilter();
    }
  }

  downloadCsv() {
    const keys = this.table.columns.map(col => col.name);
    const titles = this.table.columns.map(col => col.title);
    downloadCSV({rows: this.table.rows, keys, titles});
  }
  downloadMain(type) {
    this.downloaded.emit(type);
  }
  downloadPdf() {
    const keys = this.table.columns.map(col => col.name);
    const titles = this.table.columns.map(col => col.title);
    let row1 = ['Value 1', 'Value 2', 'Value 3', 'Value 4'];
    
    //console.log(row1);
    let values = downloadPDF({ rows: this.table.rows, keys });

    let row2 = [{ text: 'Bold value', bold: true }, 'Val 2', 'Val 3', 'Val 4'];
    var docDefinition = {
      content: [
        {
          layout: 'lightHorizontalLines', // optional
          table: {
            // headers are automatically repeated if the table spans over multiple pages
            // you can declare how many rows should be treated as headers
            headerRows: 1,
            widths: ['*', 'auto', 100, '*'],

            body: [
              row1,
              //values
            ]
          }
        }
      ]
    };

    //pdfMake.tableLayouts = {
    //  exampleLayout: {
    //    hLineWidth: function (i, node) {
    //      if (i === 0 || i === node.table.body.length) {
    //        return 0;
    //      }
    //      return (i === node.table.headerRows) ? 2 : 1;
    //    },
    //    vLineWidth: function (i) {
    //      return 0;
    //    },
    //    hLineColor: function (i) {
    //      return i === 1 ? 'black' : '#aaa';
    //    },
    //    paddingLeft: function (i) {
    //      return i === 0 ? 0 : 8;
    //    },
    //    paddingRight: function (i, node) {
    //      return (i === node.table.widths.length - 1) ? 0 : 8;
    //    }
    //  }
    //};

    pdfMake.createPdf(docDefinition).download("Report");
  }

  createActionClick() {
    this.create.emit();
  }

  modifyFilter() {
    //this.router.navigate([{ outlets: { filterPopup: ['filters'], configPopup: null } }]);
    let selectedMainFilterCrieriaName = 'null';
    this.commonFilterService.mainFilter_CriteriaName.subscribe(res => selectedMainFilterCrieriaName = res);
    this.router.navigate([{ outlets: { filterPopup: ['filters', selectedMainFilterCrieriaName], configPopup: null } }]);

    /////// when calling modify search set mainfilter to initial values
    //this.commonFilterService.SetMainFilter(0);// set selected mainfilter id
    //this.commonFilterService.setMFCustDT("");
    //this.commonFilterService.setMFTZON(0);
    ////this.commonFilterService.basicRefresh();
  }

  clearAllFilters() {
    this.table.sorter.sortMeta = [];
    //this.table.events.onSort();//IMP- to reset sorting sel cols to none

    ////if (this.table.dataFilter.hasFilters()) {
      this.table.dataFilter.clear();
      ////console.log(this.table.dataFilter.hasFilters())

      //this.table.events.onFilter();

      ////this.table.events.onFilterClear();
      this.clearFilters.emit();
    ////}
  }

  getPages(): number[] {
    const maxSize = 3;
    const pages: number[] = [];
    let startPage = 1;
    const totalPages = this.totalPages();
    let endPage = totalPages;

    if (maxSize < totalPages) {
      startPage = Math.max(this.currentPage - Math.floor(maxSize / 2), 1);
      endPage = startPage + maxSize - 1;

      if (endPage > totalPages) {
        endPage = totalPages;
        startPage = endPage - maxSize + 1;
      }
    }
    for (let num = startPage; num <= endPage; num++) {
      pages.push(num);
    }
    return pages;
  }
  totalPages(): number {
    const totalPages = this.perPage < 1 ? 1 : Math.ceil(this.totalItems / this.perPage);
    return Math.max(totalPages || 0, 1);
  }
  onChangePageSize(pageSize: number) {
    this.perPage = pageSize;
    this.currentPage = 1;//start from the beginning but not from the page selected
    this.pageChanged.emit({ currentPage: this.currentPage, perPage: this.perPage } as PageEvent);

    let paginationInfo: any = {
      PageNumber: this.currentPage,
      RecordsPerPage: this.perPage,
    }
    //console.log(paginationInfo)
    this.commonFilterService.setPaginationFilterData(paginationInfo);
    this.commonFilterService.ListenPaging();
  }

  SetTimestampSearch(tsSearch) {
    switch (tsSearch) {
      case 0:
        return "CALL_TIMESTAMP";
      case 1:
        return "VQUAD_TIMESTAMP";
      case 2:
        return "VQT_Timestamp";
      case 3:
        return "DCOSS_TIMESTAMP";
    }

  }

  callEventErrorOrNot: boolean = false;
  GetCallEventError() {
    this.callEventErrorOrNot = !this.callEventErrorOrNot;
    this.commonFilterService.setCallEventErrorEvent(this.callEventErrorOrNot);
    this.calleventErrorEvents.emit(this.callEventErrorOrNot);
  }

  connDropOrNot: boolean = false;
  GetConnDrop() {
    this.connDropOrNot = !this.connDropOrNot;
    this.commonFilterService.setConnDropEvent(this.connDropOrNot);
    this.connDropEvents.emit(this.connDropOrNot);
  }

  pdfFilePathNew = "/Webviewer/assets/DowloadedScripts/WebViewerColumnDefinitionHelp.pdf";//http://localhost:4200/assets/DowloadedScripts/WebViewerColumnDefinitionHelp.pdf

  OpenHelp() {

    let pdfFilePath = '/Webviewer/assets/DowloadedScripts/WebViewerColumnDefinitionHelp.pdf';  //// '/Webviewer/assets/images/ITS/ITSHelp.pdf?v=6.4.20';

    const windowFeatures = 'menubar=no,toolbar=no,location=no,status=no,scrollbars=yes,resizable=yes,height = ' + screen.height * .66 + ',width=' + screen.width * .66;
    // Open the popup window
    //const popupWindow = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    const popupWindow = window.open('', '_blank', windowFeatures);

    popupWindow.document.open();
    popupWindow.document.write(`
				<html>
					<head>
						<title>WebViewer Common Column Headers Definition Help</title>
						
            <body onload=""><iframe src="${pdfFilePath}" width="100%" height="100%"></iframe></body>
          </head>
        </html>
      `)
    popupWindow.document.close();
    // Write the HTML content to the popup window
    //    popupWindow.document.write(`
    //  <html>
    //    <body>
    //      <iframe src="${pdfFilePath}" width="600" height="400"></iframe>      
    //    </body>
    //  </html>
    //`);

    //    // Make sure to close the document write operation
    //    popupWindow.document.close();

  }

}
